<template>
  <div class="card" v-if="trackings && statistics">
    <div class="card--content">
      <div class="grid">
        <div class="card--header-left">
          <strong>{{leadsPerDay}}</strong> {{$t('statistics.leads_per_day')}}
        </div>
        <div class="card--header-right">
          <strong>{{leadsPerDetector}}</strong> {{$t('statistics.leads_per_lead_detector')}}
        </div>
      </div>
      <div v-if="trackings.resources">
        <leads-count-chart :start-date="startDate" :end-date="endDate" :leads-count="leadsCount" v-if="leadsCount" />
        <div v-else class="is-empty">
          {{$t('statistics.no_data')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeadsCountChart from '@/components/helpers/Specific/LeadsCountChart'

export default {
  name: 'leads-chart',
  props: ['statistics', 'leadsCount', 'trackings', 'startDate', 'endDate'],
  components: { LeadsCountChart },
  computed: {
    leadsPerDay(){
      let start_date = new moment(this.startDate)
      let end_date = new moment(this.endDate)

      let differenceDay = end_date.diff(start_date, 'days')
          
      let percent = this.statistics.leads_count / differenceDay
      return Math.round(percent * 100)/100
    },
    leadsPerDetector(){
      let percent = this.statistics.leads_count / this.statistics.lead_detector_count
      return Math.round(percent * 100)/100
    }
  }
}
</script>
<style lang="scss" scoped>
.card--header-left{
  text-align: left;
  font-size: 18px;
  .value{
    font-size: 34px;
  }
  @include respond-to("small") {
    font-size: 16px;
    width: 50%;
  }
}
.card--header-right{
  text-align: right;
  font-size: 14px;
  .value{
    font-size: 22px;
  }
  @include respond-to("small") {
    font-size: 16px;
    width: 50%;
  }
}
.is-empty{
  margin-top: 15px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// ProjectStatisticsLeadsChart.vue?59669054